
const placeTypes = ({ apiClient }) => ({
  list(params) {
    return apiClient.get('/places/groups', {}, params)
  },
})

export default placeTypes
